import {
  LayoutDashboard,
  Building2,
  Users,
  Settings,
  BarChart2,
  Music,
  ListMusic,
  Volume2,
  Flag,
  Mic,
  KeyRound,
  User,
  ChevronDown,
  ChevronRight,
  Smartphone,
  Mail,
  MessageSquare,
  HelpCircle,
  FileText,
  Package,
  Tag
} from 'lucide-react'
import { NavLink } from 'react-router-dom'
import { useState } from 'react'
import { useAuth } from '@/context/AuthContext'
import { hasAdminMenuAccess } from '@/lib/adminPermissions'

type MenuItem = {
  title: string;
  icon: any;
  path?: string;
  permissionKey: string;
  children?: {
    title: string;
    path: string;
    icon: any;
  }[];
}

const menuItems: MenuItem[] = [
  {
    title: 'Dashboard',
    icon: LayoutDashboard,
    path: '/dashboard',
    permissionKey: 'dashboard'
  },
  {
    title: 'Firma Yönetimi',
    icon: Building2,
    path: '/companies',
    permissionKey: 'companies'
  },
  {
    title: 'Email Şablonları',
    icon: Mail,
    path: '/email-templates',
    permissionKey: 'email-templates'
  },
  {
    title: 'Destek Talepleri',
    icon: MessageSquare,
    path: '/tickets',
    permissionKey: 'tickets'
  },
  {
    title: 'Yardım Makaleleri',
    icon: HelpCircle,
    path: '/help-articles',
    permissionKey: 'help-articles'
  },
  {
    title: 'Kullanıcı Yönetimi',
    icon: Users,
    path: '/users',
    permissionKey: 'users'
  },
  {
    title: 'Cihaz Yönetimi',
    icon: Smartphone,
    path: '/devices',
    permissionKey: 'devices'
  },
  {
    title: 'Cihaz Logları',
    icon: FileText,
    path: '/device-logs',
    permissionKey: 'device-logs'
  },
  {
    title: 'Anonslar',
    icon: Volume2,
    path: '/announcements',
    permissionKey: 'announcements'
  },
  {
    title: 'AI Anonslar',
    icon: Mic,
    permissionKey: 'ai-announcements',
    children: [
      {
        title: 'API Ayarları',
        path: '/ai-announcements/api-settings',
        icon: KeyRound
      },
      {
        title: 'Ses Modelleri',
        path: '/ai-announcements/voice-models',
        icon: Volume2
      },
      {
        title: 'Müzik Koleksiyonu',
        path: '/ai-announcements/music-collection',
        icon: Music
      },
      {
        title: 'Kullanıcı Erişimi',
        path: '/ai-announcements/user-access',
        icon: User
      },
    ]
  },
  {
    title: 'AI Müzik',
    icon: Package,
    path: '/ai-music/packages',
    permissionKey: 'ai-music'
  },
  {
    title: 'Müzik Yükleme',
    icon: Music,
    path: '/music/upload',
    permissionKey: 'music-upload'
  },
  {
    title: 'Playlist Yönetimi',
    icon: ListMusic,
    path: '/playlists',
    permissionKey: 'playlists'
  },
  {
    title: 'Taksonomi',
    icon: Tag,
    path: '/taxonomy',
    permissionKey: 'taxonomy'
  },
  {
    title: 'Duyurular',
    icon: Flag,
    path: '/notices',
    permissionKey: 'notices'
  },
  {
    title: 'Analitik',
    icon: BarChart2,
    path: '/analytics',
    permissionKey: 'analytics'
  },
  {
    title: 'Sistem Ayarları',
    icon: Settings,
    path: '/system-settings',
    permissionKey: 'system-settings'
  }
]

const Sidebar = () => {
  // Hangi menülerin açık olduğunu takip etmek için durum
  const [openMenus, setOpenMenus] = useState<Record<string, boolean>>({})
  const { user } = useAuth()
  const visibleMenuItems = menuItems.filter((item) => hasAdminMenuAccess(user, item.permissionKey))

  // Alt menü açma/kapama işlevi
  const toggleSubmenu = (title: string) => {
    setOpenMenus(prev => ({
      ...prev,
      [title]: !prev[title]
    }))
  }

  return (
    <div className="space-y-2">
      {visibleMenuItems.map((item) => (
        <div key={item.title}>
          {item.path ? (
            // Path'i olan menü öğesi - normal NavLink
            <NavLink
              to={item.path}
              className={({ isActive }) =>
                `flex items-center p-2 rounded-lg group ${
                  isActive ? 'bg-primary text-primary-foreground' : 'text-foreground hover:bg-muted'
                }`
              }
            >
              <item.icon size={20} />
              <span className="ml-3">{item.title}</span>
            </NavLink>
          ) : (
            // Alt menüye sahip öğe
            <div>
              <div 
                className="flex items-center justify-between p-2 rounded-lg hover:bg-muted cursor-pointer text-foreground"
                onClick={() => toggleSubmenu(item.title)}
              >
                <div className="flex items-center">
                  <item.icon size={20} />
                  <span className="ml-3">{item.title}</span>
                </div>
                {openMenus[item.title] ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
              </div>
              
              {/* Alt menü */}
              {openMenus[item.title] && item.children && (
                <div className="ml-4 pl-2 border-l border-border space-y-1 my-1">
                  {item.children.map((child) => (
                    <NavLink
                      key={child.path}
                      to={child.path}
                      className={({ isActive }) =>
                        `flex items-center p-2 rounded-lg group ${
                          isActive ? 'bg-primary text-primary-foreground' : 'text-foreground hover:bg-muted'
                        }`
                      }
                    >
                      <child.icon size={16} />
                      <span className="ml-2 text-sm">{child.title}</span>
                    </NavLink>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default Sidebar

